import { LocalizedText, LocalizedTextProps } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';

interface Props {
    bookablePeriod: 'Month' | 'Night' | 'Day' | 'Hour';
    substitutes: LocalizedTextProps['substitutes'];
}
export const LocalizedSelectedBookablePeriod = ({ bookablePeriod, substitutes }: Props) => {
    const bookablePeriodTextKey = textKeys[bookablePeriod];
    return <LocalizedText textKey={bookablePeriodTextKey} substitutes={substitutes} />;
};

const textKeys = {
    Day: TextKey.SelectedDays,
    Night: TextKey.SelectedNights,
    Hour: TextKey.SelectedHours,
    Month: TextKey.SelectedMonths,
};
